import { Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import ScrollToTop from "./Components/ScrollToTop";

const MainPage = lazy(() =>                  import("./Pages/MainPage"));
const LoginPage = lazy(() =>                 import("./Pages/LoginPage"));
const SignupPage = lazy(() =>                import("./Pages/SignupPage"));
const AboutPage = lazy(() =>                 import("./Pages/AboutPage"));
const QuotePage = lazy(() =>                 import("./Pages/QuotePage"));
const PolicyPage = lazy(() =>                import("./Pages/PolicyPage"));
const FAQPage = lazy(() =>                   import("./Pages/FAQPage"));
const AlertSettingPage = lazy(() =>          import("./Pages/AlertSettingPage"));
const CoalitionPage = lazy(() =>             import("./Pages/CoalitionPage"));
const IconDescriptionPage = lazy(() =>       import("./Pages/IconDescriptionPage"));
const AgentPage = lazy(() =>                 import("./Pages/AgentPage"));
const ResetPwPage = lazy(() =>               import("./Pages/ResetPwPage"));
const NoticePage = lazy(() =>                import("./Pages/NoticePage"));
const DefaultUserProfilePage = lazy(() =>    import("./Pages/DefaultUserProfilePage"));
const MemberProfilePage = lazy(() =>         import("./Pages/MemberProfilePage"));
const MemberProfileEditPage = lazy(() =>     import("./Pages/MemberProfileEditPage"));
const RequotePage = lazy(() =>               import("./Pages/RequotePage"));
const QuoteListPage = lazy(() =>             import("./Pages/QuoteListPage"));
const QuoteInfoPage = lazy(() =>             import("./Pages/QuoteInfoPage"));
const RequoteInfoPage = lazy(() =>           import("./Pages/RequoteInfoPage"));
const SubscriptionPage = lazy(() =>          import("./Pages/SubscriptionPage"));
const PurchasePage = lazy(() =>              import("./Pages/PurchasePage"));
const NotFound = lazy(() =>                  import("./Pages/NotFound"));
const DownloadPage = lazy(() =>              import("./Pages/DownloadPage"));

function Loading() {
    return (
      <div style={{position: 'fixed', top: '50px', left: 0, bottom: 0, right: 0, backgroundColor: 'white', zIndex: 30}}>
      </div>
    );
}

export default function Router() {

    useEffect(() => {
        if(localStorage.getItem('user') === null) {
            localStorage.setItem('user', 'guest');
        }
    });

    return (
        <div>
            <ScrollToTop /> {/* 페이지 이동 시 맨 위로 스크롤 */}
            <Suspense fallback={<Loading />}>
                <Routes>
                    {/* 메인 페이지 */} <Route path="/" element={<MainPage />} />
                    {/* 로그인 페이지 */} <Route path="/login" element={<LoginPage />} />
                    {/* 회원가입 페이지 */} <Route path="/signup" element={<SignupPage />} />
                    {/* 비밀번호 재설정 페이지 */} <Route path="/resetpw" element={<ResetPwPage />} />
                    {/* 행정마당이란? 페이지 */} <Route path="/about" element={<AboutPage />} />
                    {/* 아이콘 설명 페이지 */} <Route path="/icondesc/:id" element={<IconDescriptionPage />} />
                    {/* 견적요청 페이지 */} <Route path="/quote" element={<QuotePage />} />
                    {/* 견적 정보 페이지 */} <Route path="/quoteinfo/:id" element={<QuoteInfoPage />} />
                    {/* 견적 정보 페이지 */} <Route path="/quoteinfo/:id/:adopted" element={<QuoteInfoPage />} />
                    {/* 알림 설정 페이지 */} <Route path="/alert" element={<AlertSettingPage />} />
                    {/* 고객센터 페이지 */} <Route path="/agent" element={<AgentPage />} />
                    {/* 약관 페이지 */} <Route path="/policy/:param_id" element={<PolicyPage />} />
                    {/* 자주묻는질문 페이지 */} <Route path="/FAQ" element={<FAQPage />} />
                                        <Route path="/FAQ/:type" element={<FAQPage />} />
                    {/* 공지사항 페이지 */} <Route path="/notice" element={<NoticePage />} />
                                        <Route path="/notice/:type" element={<NoticePage />} />
                    {/* 의뢰 리스트 페이지 */} <Route path="/quote_list" element={<QuoteListPage />} />
                    {/* 다운로드 페이지 */} <Route path="/download/:quote/:index" element={<DownloadPage />} />

                    {/* 기본 유저 프로필 페이지: 추후 제거 */} <Route path="/profile/default" element={<DefaultUserProfilePage />} />
                    {/* 제휴 신청 페이지 */} <Route path="/coalition" element={<CoalitionPage />} />
                    {/* 받은 견적 상세보기 */} <Route path="/requoteinfo/:id" element={<RequoteInfoPage /> } />

                    {/* 멤버십 유저 프로필 페이지 */} <Route path="/profile/member" element={<MemberProfilePage />} />
                                                <Route path="/profile/member/:id" element={<MemberProfilePage />} />
                    {/* 멤버십 유저 프로필 페이지 수정 */} <Route path="/profile/edit/member" element={<MemberProfileEditPage />} />
                    {/* 견적 요청 답변 페이지 */} <Route path="/requote/:id" element={<RequotePage />} />
                    {/* 멤버십 구독 페이지 */} <Route path="/subscription" element={<SubscriptionPage />} />
                    {/* 구매 페이지 */} <Route path="/purchase" element={<PurchasePage />} />

                    {/* 404 페이지 */} <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </div>
    );
}